
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[articleSlug]",
      function () {
        return require("private-next-pages/blog/[articleSlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[articleSlug]"])
      });
    }
  